import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';
import { TimeBasedSettingForAllCallersDto } from '../../../dto/timebasedsetting/timebasedsettingforallcallersdto';

export interface TimeBasedSettingForAllCallersRequest extends APIRequest
{
    getTimeBasedSettingForAllCallersRequest(): TimeBasedSettingForAllCallersDto;
}

export class TimeBasedSettingForAllCallersRequestImpl extends APIRequestDtoImpl implements TimeBasedSettingForAllCallersRequest
{
    constructor(private timeBasedSettingForAllCallersData: TimeBasedSettingForAllCallersDto)
    {
        super();
    }

    getTimeBasedSettingForAllCallersRequest(): TimeBasedSettingForAllCallersDto
    {
        return this.timeBasedSettingForAllCallersData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersrequest.tsx